import React from "react";
import "./Blog.css";

import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import isolation3 from "../../Images/Isolation_Mode (3).png";
import Header2 from "../../Layout/Header2";
import button from "../../Images/Group 1171279371.png";
import BlogPost from "./BlogPost";
const Blog = () => {
  return (
    <div className="blog_mx">
      <div className="blog_wrapper">
        <div className="pricing_plans_container">
          <Header2 />
          <div>
            <h1 className=" about_head">
              Blogs
              <span>
                <img className="img_logo2" src={headlogo} />
              </span>
            </h1>
            <p
              className="about_head_para"
              style={{ width: "80%", margin: "20px auto" }}
            >
              thewinner2 is a real estate data provider offering verified
              property leads, dealer databases, and market insights to help
              agents, brokers, and investors close deals faster. With accurate
              and updated data, it simplifies lead generation and boosts sales
              performance in the real estate industry.
            </p>
          </div>
          <img className="isolation_img_5" src={isolation} />
          <img className="isolation_img_6" src={isolation2} />
         
        </div>
        <div className="blog_container">
          <div className="top_home_wrapper">
            <div className="top_left">
              <h1>
                Top Home Renovations That Increase <br /> Property Value
              </h1>
             
            </div>
            <div className="top_right">
              <img src={button} />
            </div>
          </div>
          <BlogPost />
        </div>
      </div>
    </div>
  );
};

export default Blog;
